import React, {useState, useEffect} from 'react';
import {Grid as GridView, Form, Input} from 'semantic-ui-react';
import Dropdown from '../../../components/Dropdown';
import {apiGet} from '../../../services/apiClient';
import {getRoles} from '../../../services/userRights';
import './MassUploadFilters.css';

const MassUploadFilters = ({
    statusFilter,
    authorFilter,
    companyFilter,
    searchTerm,
    onStatusChange,
    onAuthorChange,
    onCompanyChange,
    onSearchChange,
    authors = [],
    availableCompanyIds = []
}) => {
    const [companies, setCompanies] = useState([]);
    const [isCoordinator, setIsCoordinator] = useState(false);
    
    // Проверяем роль пользователя - только Coordinator (КМ)
    useEffect(() => {
        const roles = getRoles() || [];
        const isCoord = roles.includes('Coordinator');
        setIsCoordinator(isCoord);

        if (!isCoord) {
            setCompanies([]);
            return;
        }

        apiGet('ref/companies/list')
            .then(data => {
                const allowedIds = new Set((availableCompanyIds || []).map(id => id.toString()));
                const companyOptions = (data.entries || [])
                    .filter(company => allowedIds.size === 0 || allowedIds.has(company.id.toString()))
                    .map(company => ({
                        text: company.name || `Компания ${company.id}`,
                        value: company.id.toString()
                    }));
                setCompanies(companyOptions);
            })
            .catch(err => {
                console.error('Ошибка при загрузке списка компаний:', err);
            });
    }, [availableCompanyIds]);
    
    // Формируем список опций для фильтра авторов
    // Авторы уже отфильтрованы в родительском компоненте по выбранному ЮЛ
    const authorOptions = [
        {text: 'Все авторы', value: ''},
        ...authors.map(author => ({
            text: author.name || `Пользователь ${author.id}`,
            value: author.id.toString()
        }))
    ];
    
    // Формируем список опций для фильтра компаний
    const companyOptions = [
        {text: 'Все компании', value: ''},
        ...companies
    ];
    
    return (
        <div className='mass-upload-filters'>
            <GridView>
                <GridView.Row columns={isCoordinator ? 4 : 3} verticalAlign="top">
                    <GridView.Column>
                        <Form.Field>
                            <label>Поиск по названию файла</label>
                            <Input
                                placeholder="Введите название файла"
                                value={searchTerm}
                                onChange={(e) => onSearchChange(e.target.value)}
                                icon="search"
                                iconPosition="left"
                                fluid
                            />
                        </Form.Field>
                    </GridView.Column>
                    <GridView.Column>
                        <Form.Field>
                            <label>Статус</label>
                            <Dropdown
                                name="statusFilter"
                                value={statusFilter}
                                onChange={(e, {value}) => onStatusChange(value)}
                                placeholder="Все статусы"
                                options={[
                                    {text: 'Все', value: ''},
                                    {text: 'В обработке', value: 'Processing'},
                                    {text: 'Обработан', value: 'Completed'},
                                    {text: 'Накладные созданы', value: 'ParcelsCreated'},
                                    {text: 'Ошибка', value: 'Error'}
                                ]}
                                search={false}
                                fluid
                            />
                        </Form.Field>
                    </GridView.Column>
                    {isCoordinator && (
                        <GridView.Column>
                            <Form.Field>
                                <label>Юр. лицо</label>
                                <Dropdown
                                    name="companyFilter"
                                    value={companyFilter}
                                    onChange={(e, {value}) => onCompanyChange(value)}
                                    placeholder="Все компании"
                                    options={companyOptions}
                                    search={true}
                                    clearable
                                    fluid
                                />
                            </Form.Field>
                        </GridView.Column>
                    )}
                    <GridView.Column>
                        <Form.Field>
                            <label>Автор</label>
                            <Dropdown
                                name="authorFilter"
                                value={authorFilter}
                                onChange={(e, {value}) => onAuthorChange(value)}
                                placeholder="Все авторы"
                                options={authorOptions}
                                search={true}
                                clearable
                                fluid
                            />
                        </Form.Field>
                    </GridView.Column>
                </GridView.Row>
            </GridView>
        </div>
    );
};

export default MassUploadFilters;
 


// WEBPACK FOOTER //
// ./App/pages/massUpload/components/MassUploadFilters.jsx